"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  BILLING_WRITE: 'billing-write',
  PARTNER_LEAD_REGISTRATION: 'partner-lead-registration',
  DIRECTORY_USER: 'partner-join-program',
  MARKETABLE_CONTACTS_WRITE: 'marketable-contacts-write',
  MARKETABLE_CONTACTS_ACCESS: 'marketable-contacts-access',
  CRM_ACCESS: 'crm-access',
  CONTACTS_READ: 'contacts-read'
};
exports.default = _default;
module.exports = exports.default;